import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import FAQ from './components/FAQ';
import ServiceArea from './components/ServiceArea';
import Gallery from './components/Gallery';
import About from './components/About';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <WhyChoose />
      <ServiceArea />
      <Gallery />
      <About />
      {/* <Testimonials /> */}
      <FAQ />

      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
